import React from 'react';

const SidebarSubmenu = ({ 
  children, 
  expanded, 
  collapsed, 
  activeSubTab, 
  currentAction,
  onSubItemClick 
}) => {
  if (!expanded || collapsed || !children || children.length === 0) {
    return null;
  }

  return (
    <div
      className="sidebar-submenu-container"
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '1px',
        marginTop: '1px',
        marginBottom: '4px',
        transition: 'all 150ms ease-in-out'
      }}
    >
      {children.map((sub) => {
        const isSubActive = Boolean(
          (sub.subTab && activeSubTab === sub.subTab) ||
          (sub.actionType && currentAction === sub.actionType)
        );

        return (
          <button
            key={sub.id}
            type="button"
            className={`sidebar-subitem ${isSubActive ? 'active' : ''}`}
            onClick={(e) => {
              e.stopPropagation();
              onSubItemClick(sub);
            }}
            aria-current={isSubActive ? 'page' : undefined}
            style={{
              display: 'flex',
              alignItems: 'center',
              width: 'calc(100% - 16px)',
              height: '32px',
              margin: '1px 8px',
              paddingLeft: '36px',
              paddingRight: '10px',
              fontSize: '13px',
              fontWeight: isSubActive ? '600' : '400',
              color: isSubActive ? '#2563eb' : '#64748b',
              background: isSubActive ? '#f1f5ff' : 'transparent',
              border: 'none',
              borderRadius: '6px',
              cursor: 'pointer',
              textAlign: 'left',
              transition: 'all 0.12s ease',
              outline: 'none',
              boxSizing: 'border-box'
            }}
            onMouseOver={(e) => {
              if (!isSubActive) {
                e.currentTarget.style.background = '#f8fafc';
                e.currentTarget.style.color = '#0f172a';
              }
            }}
            onMouseOut={(e) => {
              if (!isSubActive) {
                e.currentTarget.style.background = 'transparent';
                e.currentTarget.style.color = '#64748b';
              }
            }}
          >
            {isSubActive && (
              <span style={{
                width: '4px',
                height: '4px',
                borderRadius: '50%',
                background: '#2563eb',
                marginRight: '8px',
                flexShrink: 0
              }} />
            )}
            <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
              {sub.label}
            </span>
          </button>
        );
      })}
    </div>
  );
};

export default SidebarSubmenu;
